import { AutenticacaoService } from './../../app-services/autenticacao.service';
import { XHRBackend, RequestOptions, Http } from "@angular/http";
import { HttpClient } from "./HttpClient";

export function httpClientFactory(xhrBackend: XHRBackend, requestOptions: RequestOptions): Http {
  return new HttpClient(xhrBackend, requestOptions);
}


// WEBPACK FOOTER //
// ./src/app/utils/http-client/httpClientFactory.ts